import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import Swal from 'sweetalert2';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SharedService } from './../../../shared/shared.service';
import { LoaderService } from './../../../core/services/loader.service';
import { UmdService } from '../../../core/services/umd.services';
import { NotificationService } from '../../../shared/notification.service';
import _ from 'lodash';
import { Helper } from '../../../core/helpers/helper';
import { Validations } from '../../../shared/constants/validations';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import {
  SelectableMode,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
@Component({
  selector: 'app-rp-tab-utilities',
  templateUrl: './rp-tab-utilities.component.html',
  styleUrl: './rp-tab-utilities.component.scss'
})
export class RpTabUtilitiesComponent {
  // file upload
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  currentUser: any;
  projectId: any;
  getUtilitiesData: any;
  public selectableSettings!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';
  isUploading: boolean = false;
  utilitiesForm!: UntypedFormGroup;
  electricityTypeItems: any;
  waterTypeItems: any;
  triSourceItems: any;
  evTypeItems: any;
  configData: any = [];
  electricityId: any;
  triSourceId: any;
  waterID: any;
  gasId: any;
  evId: any;
  isAllOpen: boolean = true;
  submitted: boolean = false;
  utility_gas_Validations = Validations.gas;
  utility_water_Validations = Validations.water;
  utility_electricity_Validations = Validations.electricity;
  utility_sqFeet_Validations = Validations.sqFeet;
  isSqftBilling: boolean = false

  constructor(
    private fb: FormBuilder,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private umdService: UmdService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    console.log(this.currentUser);
    this.isSqftBilling = this.currentUser?.project?.isSqftBilling;

    this.projectId = this.currentUser?.project.id;
    const hasGas = this.isUtilityDisplay('Gas');
    const hasWater = this.isUtilityDisplay('Water');
    const hasElectricity = this.isUtilityDisplay('Electricity');
    const hasTriSource = this.isUtilityDisplay('TriSource');
    const hasEV = this.isUtilityDisplay('EV');
    console.log('Utilities Display - Gas:', hasGas, 'Water:', hasWater, 'Electricity:', hasElectricity, 'TriSource:', hasTriSource);
    this.utilitiesForm = this.fb.group({
      /*   water: this.fb.array( [this.createSqftRange('Water')], {
          validators: Helper.sqftRangeSequentialValidator()
        }),
  
        electricity: this.fb.array([this.createSqftRange('Electricity')], {
          validators: Helper.sqftRangeSequentialValidator()
        }),
  
        trisource: this.fb.array([this.createSqftRange('TriSource')], {
          validators: Helper.sqftRangeSequentialValidator()
        }), */
      /*  water: this.fb.array(hasWater ? [this.createSqftRange('Water')] : []),
       electricity: this.fb.array(hasElectricity ? [this.createSqftRange('Electricity')] : []),
       trisource: this.fb.array(hasTriSource ? [this.createSqftRange('TriSource')] : []), */
      water: hasWater
        ? this.fb.array([this.createSqftRange('Water')], { validators: Helper.sqftRangeSequentialValidator() })
        : this.fb.array([]),

      electricity: hasElectricity
        ? this.fb.array([this.createSqftRange('Electricity')], { validators: Helper.sqftRangeSequentialValidator() })
        : this.fb.array([]),

      trisource: hasTriSource
        ? this.fb.array([this.createSqftRange('TriSource')], { validators: Helper.sqftRangeSequentialValidator() })
        : this.fb.array([]),

      EV: hasEV ? this.fb.array([this.createEVGroup()]) : this.fb.array([]),

      gas: this.formBuilder.group({
        utilityMasterId: hasGas ? this.gasId : '',
        id: '00000000-0000-0000-0000-000000000000',
        gasValue: [

          { value: '', disabled: !hasGas },
          hasGas
            ? [
              Validators.required,
              Validators.minLength(1),
              Validators.maxLength(20),
              Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
            ]
            : [],
        ],
        UnitLPGValue: [
          { value: '', disabled: !hasGas },
          hasGas
            ? [
              Validators.required,
              Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
            ]
            : [],
        ],
        unitPrice: [
          { value: '', disabled: !hasGas },
          hasGas
            ? [
              Validators.required,
              Helper.maxValueValidator(99999),
              Helper.PatternValidator(
                /^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/
              ),
            ]
            : [],
        ],

      }),
      GasFile: null,
      projectId: this.projectId,
      WaterFile: null,
      ElectricityFile: null,
      triSourceFile: null,
      EVFile: null,
      removedUtilityIds: this.formBuilder.array([]),
      IsGasFileDeleted: false,
      IsWaterFileDeleted: false,
      IsTriSourceFileDeleted: false,
      IsElectricityFileDeleted: false,
      IsEVFileDeleted: false,
    });
    this.getAllConfigData();
  }
  ngOnInit(): void {
    this.loaderService.setLoading(true);
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };

    this.utilitiesForm
      .get('gas.gasValue')
      ?.valueChanges.subscribe(() => this.calculateUnitPrice());
    this.utilitiesForm
      .get('gas.UnitLPGValue')
      ?.valueChanges.subscribe(() => this.calculateUnitPrice());
    this.getUtilities()
  }

  bindUtilitiesData2(data: any) {

    /** ------------ GAS SECTION ------------ **/
    if (data.gas) {
      this.utilitiesForm.get('gas')?.patchValue({
        id: data.gas.id,
        utilityMasterId: data.gas.utilityMasterId,
        gasValue: data.gas.gasValue,
        UnitLPGValue: data.gas.unitLPGValue,
        unitPrice: data.gas.unitPrice
      });
    }

    /** Helper function to fill ANY utility formArray (Water/Electricity/TriSource) */
    const fillUtilityFA = (arrayName: string, sourceData: any[]) => {
      const fa = this.utilitiesForm.get(arrayName) as FormArray;
      fa.clear();

      /*   sourceData.forEach(item => {
          const rangeFG = this.createSqftRange(arrayName);
          rangeFG.patchValue({
            sqftMin: item.sqftMinValue,
            sqftMax: item.sqftMaxValue
          });
  
         
          const slabsFA = rangeFG.get('slabs') as FormArray;
          slabsFA.clear();
  
          item.slabs.forEach((slab: any) => {
            const slabFG = this.createSlab();
            slabFG.patchValue({
              id: slab.id,
              utilityMasterId: item.utilityMasterId,
              slabName: slab.slabName,
              min: slab.minKwh ?? slab.minValue,
              max: slab.maxKwh ?? slab.maxValue,
              unitPrice: slab.unitPrice
            });
            slabsFA.push(slabFG);
          });
  
          fa.push(rangeFG);
        }); */
    };

    /** ------------ WATER ------------ **/
    fillUtilityFA("water", data.water);

    /** ------------ ELECTRICITY ------------ **/
    fillUtilityFA("electricity", data.electricity);

    /** ------------ TRISOURCE ------------ **/
    fillUtilityFA("trisource", data.triSource);

    /** 🔥 FINAL STEP — RE-RUN ALL VALIDATIONS (critical!!) */
    setTimeout(() => {
      this.revalidateCompleteForm();
      this.loaderService.setLoading(false)
    });
  }
  revalidateCompleteForm() {
    this.utilitiesForm.markAllAsTouched();
    this.utilitiesForm.updateValueAndValidity({ emitEvent: true });

    Object.keys(this.utilitiesForm.controls).forEach(key => {
      const ctrl = this.utilitiesForm.get(key);

      if (ctrl instanceof FormArray) {
        ctrl.controls.forEach((rangeFG: any) => {
          rangeFG.markAllAsTouched();
          rangeFG.updateValueAndValidity({ emitEvent: true });

          const slabs = rangeFG.get('slabs');
          if (slabs instanceof FormArray) {
            slabs.controls.forEach((slabFG: any) => {
              slabFG.markAllAsTouched();
              slabFG.updateValueAndValidity({ emitEvent: true });
            });
          }
        });
      }

      if (ctrl instanceof FormGroup) {
        ctrl.markAllAsTouched();
        ctrl.updateValueAndValidity({ emitEvent: true });
      }
    });
  }
  // Bind server data into form (example). After patch, force validators to run.
  bindUtilitiesData(data: any) {

    const hasGas = this.isUtilityDisplay('Gas');
    const hasWater = this.isUtilityDisplay('Water');
    const hasElectricity = this.isUtilityDisplay('Electricity');
    const hasTriSource = this.isUtilityDisplay('TriSource');
    const hasEV = this.isUtilityDisplay('EV');
    /** ------------ GAS SECTION ------------ **/
    if (data.gas) {
      this.utilitiesForm.get('gas')?.patchValue({
        id: data.gas.id,
        utilityMasterId: data.gas.utilityMasterId,
        gasValue: data.gas.gasValue,
        UnitLPGValue: data.gas.unitLPGValue,
        unitPrice: data.gas.unitPrice
      });
    }


    // Clear arrays
  /* const setArray = (arrName: string, list: any[]) => {
      const fa = this.utilitiesForm.get(arrName) as FormArray;
      fa.clear();
      if (!list || !list.length) {
        fa.push(this.createSqftRange(arrName === 'water' ? 'Water' : arrName === 'electricity' ? 'Electricity' : 'TriSource'));
        return;
      }
      list.forEach((rng) => {
        const rangeFG = this.createSqftRange(arrName === 'water' ? 'Water' : arrName === 'electricity' ? 'Electricity' : 'TriSource');
        rangeFG.patchValue({
          utilityMasterId: rng.utilityMasterId,
          sqftMin: rng.sqftMin ?? rng.sqftMinValue ?? '',
          sqftMax: rng.sqftMax ?? rng.sqftMaxValue ?? '',
        });
        const slabsFA = rangeFG.get('slabs') as FormArray;
        slabsFA.clear();
        (rng.slabs || []).forEach((sb: any) => {
          const slabFG = this.createSlab();
          slabFG.patchValue({
            id: sb.id ?? '00000000-0000-0000-0000-000000000000',
            slabName: sb.slabName, // assuming id or same type used in ng-select bindValue
            min: sb.min ?? sb.minValue ?? sb.minKwh ?? '',
            max: sb.max ?? sb.maxValue ?? sb.maxKwh ?? '',
            unitPrice: sb.unitPrice ?? '',
          });
          slabsFA.push(slabFG);
        });
        fa.push(rangeFG);
      });
    }; */

    /** ------------ COMMON ARRAY BINDER ------------ **/
   /* const setArray = (arrName: string, list: any[]) => {

      const fa = this.utilitiesForm.get(arrName) as FormArray;
      if (!fa) return;

      fa.clear(); // always clear first

      // If API has no data keep array EMPTY
      if (!list || !list.length) {
        return;
      }

      list.forEach((rng) => {

        const type =
          arrName === 'water'
            ? 'Water'
            : arrName === 'electricity'
              ? 'Electricity'
              : 'TriSource';

        const rangeFG = this.createSqftRange(type);

        rangeFG.patchValue({
          utilityMasterId: rng.utilityMasterId,
          sqftMin: rng.sqftMin ?? rng.sqftMinValue ?? '',
          sqftMax: rng.sqftMax ?? rng.sqftMaxValue ?? '',
        });

        const slabsFA = rangeFG.get('slabs') as FormArray;
        slabsFA.clear();

        (rng.slabs || []).forEach((sb: any) => {
          const slabFG = this.createSlab();
          slabFG.patchValue({
            id: sb.id ?? '00000000-0000-0000-0000-000000000000',
            slabName: sb.slabName,
            min: sb.min ?? sb.minValue ?? sb.minKwh ?? '',
            max: sb.max ?? sb.maxValue ?? sb.maxKwh ?? '',
            unitPrice: sb.unitPrice ?? '',
          });
          slabsFA.push(slabFG);
        });

        fa.push(rangeFG);
      });
    };  */
    const setArray = (arrName: string, list: any[], isEnabled: boolean) => {
      const fa = this.utilitiesForm.get(arrName) as FormArray;
      fa.clear();
      if (!isEnabled) {
        return;
      }
      if (!list || !list.length) {
        fa.push(this.createSqftRange(arrName === 'water' ? 'Water' : arrName === 'electricity' ? 'Electricity' : 'TriSource'));
        return;
      }
      list.forEach((rng) => {
        const rangeFG = this.createSqftRange(arrName === 'water' ? 'Water' : arrName === 'electricity' ? 'Electricity' : 'TriSource');
        rangeFG.patchValue({
          utilityMasterId: rng.utilityMasterId,
          sqftMin: rng.sqftMin ?? rng.sqftMinValue ?? '',
          sqftMax: rng.sqftMax ?? rng.sqftMaxValue ?? '',
        });
        const slabsFA = rangeFG.get('slabs') as FormArray;
        slabsFA.clear();
        (rng.slabs || []).forEach((sb: any) => {
          const slabFG = this.createSlab();
          slabFG.patchValue({
            id: sb.id ?? '00000000-0000-0000-0000-000000000000',
            slabName: sb.slabName, // assuming id or same type used in ng-select bindValue
            min: sb.min ?? sb.minValue ?? sb.minKwh ?? '',
            max: sb.max ?? sb.maxValue ?? sb.maxKwh ?? '',
            unitPrice: sb.unitPrice ?? '',
          });
          slabsFA.push(slabFG);
        });
        fa.push(rangeFG);
      });
    };
  
    setArray('water', data.water || [], hasWater);
    setArray('electricity', data.electricity || [], hasElectricity);
    setArray('trisource', data.triSource || [], hasTriSource);
    this.setEVArray(data.EV || data.ev || data.eV || [], hasEV);

    // force validation for all below
    [this.waterRangeArray, this.electricRangeArray, this.triRangeArray].forEach((fa) => {
      fa.controls.forEach((range: AbstractControl) => {
        range.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        const slabs = this.slabsOf(range);
        slabs.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        slabs.controls.forEach((s) => s.updateValueAndValidity({ onlySelf: true, emitEvent: false }));
      });
      fa.updateValueAndValidity();
    });

    this.utilitiesForm.updateValueAndValidity();
    this.utilitiesForm.markAllAsTouched();
    setTimeout(() => {
      [this.waterRangeArray, this.electricRangeArray, this.triRangeArray].forEach((fa: FormArray) => {
        fa.controls.forEach((range: AbstractControl) => {
          range.updateValueAndValidity();
          range.markAllAsTouched();

          const slabs = this.slabsOf(range);
          slabs.controls.forEach((slab: AbstractControl) => {
            slab.updateValueAndValidity();
            slab.markAllAsTouched();
          });

          slabs.updateValueAndValidity();
        });

        fa.updateValueAndValidity();
      });
      this.forceValidateAllRanges(this.waterRangeArray);
      this.forceValidateAllRanges(this.electricRangeArray);
      this.forceValidateAllRanges(this.triRangeArray);
    });
    console.log("waterRangeArray_errors ", this.electricRangeArray.errors);
    console.log(this.utilitiesForm.getRawValue());
    this.loaderService.setLoading(false);
  }

  bindUtilitiesData_new(data: any) {



    /** ------------ GAS SECTION ------------ **/
    if (data.gas) {
      this.utilitiesForm.get('gas')?.patchValue({
        id: data.gas.id,
        utilityMasterId: data.gas.utilityMasterId,
        gasValue: data.gas.gasValue,
        UnitLPGValue: data.gas.unitLPGValue,
        unitPrice: data.gas.unitPrice
      });
    }

    /** ------------ WATER SECTION (FormArray) ------------ **/
    const waterFA = this.utilitiesForm.get('water') as FormArray;
    waterFA.clear(); // remove initial row

    data.water.forEach((item: any) => {
      const rangeFG = this.createSqftRange('Water');
      rangeFG.patchValue({
        utilityMasterId: item.utilityMasterId,
        sqftMin: item.sqftMinValue,
        sqftMax: item.sqftMaxValue,
      });

      // Get slabs array inside the range
      const slabsFA = rangeFG.get('slabs') as FormArray;
      slabsFA.clear(); // remove initial slab

      item.slabs.forEach((slab: any) => {
        const slabFG = this.createSlab();
        slabFG.patchValue({
          id: slab.id,

          slabName: slab.slabName,
          min: slab.minKwh,
          max: slab.maxKwh,
          /* min: slab.minValue ?? slab.minKwh,
          max: slab.maxValue ?? slab.maxKwh, */
          unitPrice: slab.unitPrice
        });
        slabsFA.push(slabFG);
      });

      waterFA.push(rangeFG);
    });

    /** ------------ ELECTRICITY SECTION ------------ **/
    const eleFA = this.utilitiesForm.get('electricity') as FormArray;
    eleFA.clear();

    data.electricity.forEach((item: any) => {
      const rangeFG = this.createSqftRange('Electricity');
      rangeFG.patchValue({
        utilityMasterId: item.utilityMasterId,
        sqftMin: item.sqftMinValue,
        sqftMax: item.sqftMaxValue
      });

      const slabsFA = rangeFG.get('slabs') as FormArray;
      slabsFA.clear();

      item.slabs.forEach((slab: any) => {
        const slabFG = this.createSlab();
        slabFG.patchValue({
          id: slab.id,

          slabName: slab.slabName,
          /*  min: slab.minKwh ?? slab.maxKwh,
           max: slab.maxKwh ?? slab.minKwh, */
          min: slab.minKwh,
          max: slab.maxKwh,

          unitPrice: slab.unitPrice
        });
        slabsFA.push(slabFG);
      });

      eleFA.push(rangeFG);
    });

    /** ------------ TRISOURCE SECTION ------------ **/


    const triFA = this.utilitiesForm.get('trisource') as FormArray;
    triFA.clear();

    data.triSource.forEach((item: any) => {
      const rangeFG = this.createSqftRange('TriSource');
      rangeFG.patchValue({
        utilityMasterId: item.utilityMasterId,
        sqftMin: item.sqftMinValue,
        sqftMax: item.sqftMaxValue
      });

      const slabsFA = rangeFG.get('slabs') as FormArray;
      slabsFA.clear();

      item.slabs.forEach((slab: any) => {
        const slabFG = this.createSlab();
        slabFG.patchValue({
          id: slab.id,

          slabName: slab.slabName,
          /*  min: slab.minKwh ?? slab.maxKwh,
           max: slab.maxKwh ?? slab.minKwh, */
          min: slab.minKwh,
          max: slab.maxKwh,
          unitPrice: slab.unitPrice
        });
        slabsFA.push(slabFG);
      });
      triFA.push(rangeFG);
      /** 🔥 Also validate parent range */
      rangeFG.updateValueAndValidity();
      rangeFG.markAllAsTouched();


    });


    setTimeout(() => {
      triFA.controls.forEach((range: any) => {
        range.updateValueAndValidity();
        range.markAllAsTouched();

        const slabsFA = range.get('slabs') as FormArray;
        slabsFA.controls.forEach((slab: any) => {
          slab.updateValueAndValidity();
          slab.markAllAsTouched();
        });
      });
    });
    /** 🔥 FORCE VALIDATION FOR ALL RANGES NOW */
    this.forceValidateAllRanges(waterFA);
    this.forceValidateAllRanges(eleFA);
    this.forceValidateAllRanges(triFA);

    /** SHOW ERRORS */
    waterFA.markAllAsTouched();
    eleFA.markAllAsTouched();
    triFA.markAllAsTouched();
    this.loaderService.setLoading(false);
    console.log(JSON.stringify(this.utilitiesForm.getRawValue(), null, 2));



  }
  forceValidateAllRanges(fa: FormArray) {
    fa.controls.forEach((range: AbstractControl) => {

      // ✅ Run sqft validators
      range.updateValueAndValidity({ emitEvent: true });

      const slabs = range.get('slabs') as FormArray;

      // ✅ Run slab array validator
      slabs.updateValueAndValidity({ emitEvent: true });

      // ✅ Run per slab validators
      slabs.controls.forEach((slab: AbstractControl) => {
        slab.updateValueAndValidity({ emitEvent: true });
        slab.markAllAsTouched();
      });

      slabs.markAllAsTouched();
    });

    fa.updateValueAndValidity({ emitEvent: true });
  }

  private triggerFullValidation() {
    Object.keys(this.utilitiesForm.controls).forEach(key => {
      const control = this.utilitiesForm.get(key);

      if (control instanceof FormArray) {
        control.controls.forEach((range: any) => {
          range.markAllAsTouched();
          range.updateValueAndValidity({ emitEvent: true });

          const slabsFA = range.get('slabs') as FormArray;
          slabsFA.controls.forEach((slab: any) => {
            slab.markAllAsTouched();
            slab.updateValueAndValidity({ emitEvent: true });
          });
        });
      }
      else if (control instanceof FormGroup) {
        control.markAllAsTouched();
        control.updateValueAndValidity();
      }
    });

    this.utilitiesForm.updateValueAndValidity({ emitEvent: true });
  }

  getUtilities() {
    this.loaderService.setLoading(true)
    this.umdService.getutilities(this.projectId).subscribe({
      next: (res) => {
        console.log(res)
        if (res && res.statusCode === 200) {
          this.getUtilitiesData = res.data;
          console.log(this.getUtilitiesData);
          console.log(this.utilitiesForm);
        
          this.bindUtilitiesData(this.getUtilitiesData);
          let gasFile = this.getUtilitiesData?.gasFile?.fileName
            ? [
              {
                name: this.getUtilitiesData?.gasFile?.fileName,
                src: this.getUtilitiesData?.gasFile?.fileUrl,
                size: this.getUtilitiesData?.gasFile?.fileSize,
                uid: this.getUtilitiesData?.gasFile?.id,
              },
            ]
            : [];

          let waterFile = this.getUtilitiesData?.waterFile?.fileName
            ? [
              {
                name: this.getUtilitiesData?.waterFile?.fileName,
                src: this.getUtilitiesData?.waterFile?.fileUrl,
                size: this.getUtilitiesData?.waterFile?.fileSize,
                uid: this.getUtilitiesData?.waterFile?.id,
              },
            ]
            : [];

          let electricityFile = this.getUtilitiesData
            ?.electricityFile?.fileName
            ? [
              {
                name: this.getUtilitiesData?.electricityFile
                  ?.fileName,
                src: this.getUtilitiesData?.electricityFile
                  ?.fileUrl,
                size: this.getUtilitiesData?.electricityFile
                  ?.fileSize,
                uid: this.getUtilitiesData?.electricityFile
                  ?.id,
                url: this.getUtilitiesData?.electricityFile
                  ?.fileUrl,
              },
            ]
            : [];

          let triSourceFile = this.getUtilitiesData?.triSourceFile
            ?.fileName
            ? [
              {
                name: this.getUtilitiesData?.triSourceFile
                  ?.fileName,
                src: this.getUtilitiesData?.triSourceFile
                  ?.fileUrl,
                size: this.getUtilitiesData?.triSourceFile
                  ?.fileSize,
                uid: this.getUtilitiesData?.triSourceFile?.id,
                url: this.getUtilitiesData?.triSourceFile
                  ?.fileUrl,
              },
            ]
            : [];

          let evFile = (this.getUtilitiesData?.EVFile ||
            this.getUtilitiesData?.evFile ||
            this.getUtilitiesData?.eVFile)?.fileName
            ? [
              {
                name: (this.getUtilitiesData?.EVFile ||
                  this.getUtilitiesData?.evFile ||
                  this.getUtilitiesData?.eVFile)?.fileName,
                src: (this.getUtilitiesData?.EVFile ||
                  this.getUtilitiesData?.evFile ||
                  this.getUtilitiesData?.eVFile)?.fileUrl,
                size: (this.getUtilitiesData?.EVFile ||
                  this.getUtilitiesData?.evFile ||
                  this.getUtilitiesData?.eVFile)?.fileSize,
                uid: (this.getUtilitiesData?.EVFile ||
                  this.getUtilitiesData?.evFile ||
                  this.getUtilitiesData?.eVFile)?.id,
                url: (this.getUtilitiesData?.EVFile ||
                  this.getUtilitiesData?.evFile ||
                  this.getUtilitiesData?.eVFile)?.fileUrl,
              },
            ]
            : [];

          console.log(this.getUtilitiesData.triSource);
          console.log(triSourceFile);
          console.log(waterFile);
          console.log(gasFile);
          console.log(electricityFile);
          this.utilitiesForm.patchValue({
            WaterFile: waterFile,
            GasFile: gasFile,
            ElectricityFile: electricityFile,
            triSourceFile: triSourceFile,
            EVFile: evFile,
          });

        }

      }, error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message ||
          'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },


    })
  }

  createSqftRange(type: string): FormGroup {
    return this.fb.group({
      utilityMasterId: type === 'Water' ? this.waterID : type === 'Electricity' ? this.electricityId : this.triSourceId,

      sqftMin: ['', Validators.required],
      sqftMax: ['', Validators.required],

      slabs: this.fb.array([this.createSlab()], {
        validators: Helper.slabSequentialValidator()
      })
    });
  }

  createEVGroup(): FormGroup {
    return this.fb.group({
      id: '00000000-0000-0000-0000-000000000000',
      utilityMasterId: this.evId,
      slabName: [null, Validators.required],
      MinValue: [0],
      MaxValue: [0],
      unitPrice: [
        '',
        [
          Validators.required,
          Helper.maxValueValidator(99999),
          Helper.PatternValidator(/^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/),
        ],
      ],
    });
  }

  private setEVArray(list: any[], isEnabled: boolean): void {
    const evArray = this.utilitiesForm.get('EV') as FormArray;
    evArray.clear();
    if (!isEnabled) {
      return;
    }

    const evSlabs = (list || []).flatMap((item: any) => item?.slabs?.length ? item.slabs : item);
    if (!evSlabs.length) {
      evArray.push(this.createEVGroup());
      return;
    }

    evSlabs.forEach((evItem: any) => {
      const evGroup = this.createEVGroup();
      evGroup.patchValue({
        id: evItem.id ?? '00000000-0000-0000-0000-000000000000',
        utilityMasterId: evItem.utilityMasterId ?? this.evId,
        slabName: evItem.slabName,
        MinValue: 0,
        MaxValue: 0,
        unitPrice: evItem.unitPrice ?? evItem.UnitPrice ?? '',
      });
      evArray.push(evGroup);
    });
  }

  private getEVPayload(): any[] {
    if (!this.evArray.length) {
      return [];
    }

    return [
      {
        utilityMasterId: this.evId,
        sqftMin: 0,
        sqftMax: 0,
        slabs: this.evArray.controls.map((control: AbstractControl) => {
          const ev = (control as FormGroup).getRawValue();
          return {
            id: ev.id ?? '00000000-0000-0000-0000-000000000000',
            utilityMasterId: ev.utilityMasterId ?? this.evId,
            slabName: ev.slabName,
            min: 0,
            max: 0,
            MinValue: 0,
            MaxValue: 0,
            unitPrice: ev.unitPrice,
          };
        }),
      },
    ];
  }




  // Single slab FormGroup
  createSlab(): FormGroup {
    return this.fb.group(
      {
        id: '00000000-0000-0000-0000-000000000000',

        slabName: [null, Validators.required],

        min: ['', [Validators.required, Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d{1,2})?$/)]],
        max: ['', [Validators.required, Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d{1,2})?$/)]],

        unitPrice: [
          '',
          [
            Validators.required,
            Helper.maxValueValidator(99999),
            Helper.PatternValidator(/^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/),
          ],
        ],
      },
      { validators: [Helper.minLessThanMaxValidator('min', 'max')] }
    );
  }


  /** Getter utilities */

  get gasForm() {
    return this.utilitiesForm.get('gas') as FormGroup;
  }
  /*  get waterRangeArray() {
     return this.utilitiesForm.get('water') as FormArray;
   }
   get electricRangeArray() {
     return this.utilitiesForm.get('electricity') as FormArray;
   }
   get triRangeArray() {
     return this.utilitiesForm.get('trisource') as FormArray;
   } */
  // Ranges FormArray helpers
  get waterRangeArray(): FormArray {
    return this.utilitiesForm.get('water') as FormArray;
  }
  get electricRangeArray(): FormArray {
    return this.utilitiesForm.get('electricity') as FormArray;
  }
  get triRangeArray(): FormArray {
    return this.utilitiesForm.get('trisource') as FormArray;
  }
  get evArray(): FormArray {
    return this.utilitiesForm.get('EV') as FormArray;
  }
  get evFileData(): any {
    return (
      this.getUtilitiesData?.EVFile ||
      this.getUtilitiesData?.evFile ||
      this.getUtilitiesData?.eVFile
    );
  }

  private isRippleEVUnitRateEnabled(): boolean {
    return !!(
      this.currentUser?.project?.isRippleUnitRate ??
      this.currentUser?.project?.IsRippleUnitRate ??
      false
    );
  }

  hasVisibleUtilityConfig(): boolean {
    return ['Gas', 'Water', 'Electricity', 'TriSource', 'EV'].some((type) =>
      this.isUtilityDisplay(type)
    );
  }

  isUtilityDisplay(type: string): boolean {
    if (type === 'EV' && !this.isRippleEVUnitRateEnabled()) {
      return false;
    }

    const projectUtilities =
      this.currentUser?.projectUtilities ??
      this.currentUser?.project?.projectUtilities ??
      this.currentUser?.project?.ProjectUtilities ??
      this.currentUser?.project?.selectedUtilities ??
      this.currentUser?.project?.SelectedUtilities ??
      this.currentUser?.project?.utilities ??
      this.currentUser?.project?.Utilities ??
      [];
    const utility = Array.isArray(projectUtilities)
      ? projectUtilities.find((u: any) => {
          const name =
            u?.name ??
            u?.Name ??
            u?.utilityName ??
            u?.UtilityName ??
            u?.master?.name ??
            u?.Master?.Name ??
            u;

          return (
            name?.toString().trim().toLowerCase() ===
            type.trim().toLowerCase()
          );
        })
      : null;
    return !!utility; // Returns true if 'Electricity' is found, false otherwise
  }
  // helper to get slabs of a given range group
  slabsOf(rangeGroup: AbstractControl): FormArray {
    return (rangeGroup.get('slabs') as FormArray) ?? this.fb.array([]);
  }
  /* slabsOf(range: any) {
    return range.get('slabs') as FormArray;
  } */
  /** Actions */
  /*  addWaterRange() {
    this.waterRangeArray.push(this.createSqftRange());
  } */
  addWaterRange(): void {
    const ranges = this.waterRangeArray;

    // Prevent adding if any range invalid
    if (ranges.invalid) {
      this.sharedService.showMessageDialog(
        '',
        'Please fix all validation errors before adding a new Square Feet Range.',
        SweetAlertIcon.INFO
      );
      ranges.markAllAsTouched();
      return;
    }

    if (ranges.length > 0) {
      const lastIndex = ranges.length - 1;
      const lastGroup = ranges.at(lastIndex);

      const min = lastGroup.get('sqftMin')?.value;
      const max = lastGroup.get('sqftMax')?.value;

      const incomplete = min === '' || max === '';

      if (incomplete) {
        this.sharedService.showMessageDialog(
          '',
          'Please complete the last Square Feet Range first.',
          SweetAlertIcon.INFO
        );

        lastGroup.markAllAsTouched();
        return;
      }

      // Cross-field: Min < Max
      if (+min >= +max) {
        lastGroup.get('sqftMax')?.setErrors({ minGreaterOrEqualMax: true });
        lastGroup.markAllAsTouched();
        return;
      }
    }

    // ✅ Passed all validation -> Add a new Sqft Range
    ranges.push(this.createSqftRange('Water'));
  }

  addElectricRange() {
    const ranges = this.electricRangeArray;

    // Prevent adding if any range invalid
    if (ranges.invalid) {
      this.sharedService.showMessageDialog(
        '',
        'Please fix all validation errors before adding a new Square Feet Range.',
        SweetAlertIcon.INFO
      );
      ranges.markAllAsTouched();
      return;
    }

    if (ranges.length > 0) {
      const lastIndex = ranges.length - 1;
      const lastGroup = ranges.at(lastIndex);

      const min = lastGroup.get('sqftMin')?.value;
      const max = lastGroup.get('sqftMax')?.value;

      const incomplete = min === '' || max === '';

      if (incomplete) {
        this.sharedService.showMessageDialog(
          '',
          'Please complete the last Square Feet Range first.',
          SweetAlertIcon.INFO
        );

        lastGroup.markAllAsTouched();
        return;
      }

      // Cross-field: Min < Max
      if (+min >= +max) {
        lastGroup.get('sqftMax')?.setErrors({ minGreaterOrEqualMax: true });
        lastGroup.markAllAsTouched();
        return;
      }
    }
    this.electricRangeArray.push(this.createSqftRange('Electricity'));
  }
  addTriRange() {
    this.triRangeArray.push(this.createSqftRange('TriSource'));
  }

  /* removeRange(array: FormArray, i: number) {
    array.removeAt(i);
  } */

  /*  addSlab(range: any) {
    this.slabsOf(range).push(this.createSlab());
  } */
  /*  addSlab(range: AbstractControl): void {
     const slabs = this.slabsOf(range);
     console.log(slabs.invalid)
    
     if (slabs.invalid) {
       this.sharedService.showMessageDialog(
         '',
         'Please fix all validation errors before adding a new row.',
         SweetAlertIcon.INFO
       );
       slabs.markAllAsTouched();
       return;
     }
 
     if (slabs.length > 0) {
       const lastIndex = slabs.length - 1;
       const lastGroup = slabs.at(lastIndex);
 
       const supplier = lastGroup.get('slabName')?.value;
       const min = lastGroup.get('min')?.value;
       const max = lastGroup.get('max')?.value;
       const unit = lastGroup.get('unitPrice')?.value;
 
       const incomplete = !supplier || min === '' || max === '' || unit === '';
 
       if (incomplete) {
         this.sharedService.showMessageDialog(
           '',
           'Please complete the last slab row first.',
           SweetAlertIcon.INFO
         );
 
         lastGroup.markAllAsTouched();
         return;
       }
 
       
       if (+min >= +max) {
         lastGroup.get('max')?.setErrors({ minGreaterOrEqualMax: true });
         lastGroup.markAllAsTouched();
         return;
       }
     }
 
     // ✅ Passed all validation
     slabs.push(this.createSlab());
   } */
  // Add slab to a specific range. Prevent adding if last slab invalid or incomplete.
  addSlab(rangeGroup: AbstractControl) {
    const slabs = this.slabsOf(rangeGroup);

    slabs.markAllAsTouched();
    slabs.updateValueAndValidity();

    // Check if last row is complete
    if (slabs.length > 0) {
      const last = slabs.at(slabs.length - 1) as FormGroup;

      const incomplete =
        !last.get('slabName')?.value ||
        last.get('min')?.value === '' ||
        last.get('max')?.value === '' ||
        last.get('unitPrice')?.value === '';

      if (incomplete) {
        this.sharedService.showMessageDialog(
          '',
          'Please complete the last slab row first.',
          SweetAlertIcon.INFO
        );
        last.markAllAsTouched();
        return;
      }

      if (+last.get('min')!.value >= +last.get('max')!.value) {
        last.get('max')!.setErrors({ minGreaterOrEqualMax: true });
        last.markAllAsTouched();
        return;
      }

      // ❗ This triggers slabSequentialValidator properly
      slabs.updateValueAndValidity();
    }

    slabs.push(this.createSlab());
  }


  removeSlab(range: AbstractControl, i: number) {
    const slabs = this.slabsOf(range);
    const slabGroup = slabs.at(i) as FormGroup;
    const removedIds = this.utilitiesForm.get('removedUtilityIds') as FormArray;
    const slabId = slabGroup?.get('id')?.value;

    if (
      slabId &&
      slabId !== '' &&
      slabId !== '00000000-0000-0000-0000-000000000000'
    ) {
      removedIds.push(this.formBuilder.control(slabId));
    }

    slabs.removeAt(i);

    // revalidate after removal
    slabs.updateValueAndValidity();
  }
  // Add new range
  addRange_new(arrayName: 'water' | 'electricity' | 'trisource') {
    const arr = this.utilitiesForm.get(arrayName) as FormArray;
    // check previous ranges are valid
    arr.markAllAsTouched();
    arr.updateValueAndValidity();
    if (arr.invalid) {
      this.sharedService.showMessageDialog(
        '',
        'Please fix all validation errors before adding a new Square Feet Range.',
        SweetAlertIcon.INFO
      );
      return;
      /*  alert('Please fix validation errors before adding new Sqft range.');
       return; */
    }
    arr.push(this.createSqftRange(arrayName === 'water' ? 'Water' : arrayName === 'electricity' ? 'Electricity' : 'TriSource'));
  }
  addRange(arrayName: 'water' | 'electricity' | 'trisource') {

    const arr = this.utilitiesForm.get(arrayName) as FormArray;

    let hasErrors = false;

    arr.controls.forEach((range: AbstractControl) => {
      range.markAllAsTouched();
      range.updateValueAndValidity({ emitEvent: false });

      const slabs = range.get('slabs') as FormArray;
      slabs.controls.forEach((slab: AbstractControl) => {
        slab.markAllAsTouched();
        slab.updateValueAndValidity({ emitEvent: false });
      });

      if (range.invalid) hasErrors = true;
    });

    if (hasErrors) {
      this.sharedService.showMessageDialog(
        '',
        'Please fix all validation errors before adding a new Square Feet Range.',
        SweetAlertIcon.INFO
      );
      return; // ❌ STOP
    }

    // ✅ Safe to add new clean row
    arr.push(
      this.createSqftRange(
        arrayName === 'water'
          ? 'Water'
          : arrayName === 'electricity'
            ? 'Electricity'
            : 'TriSource'
      )
    );

  }

  removeRange(formArray: FormArray, index: number) {
    formArray.removeAt(index);
    formArray.updateValueAndValidity();
  }

  addEV(): void {
    const evArray = this.evArray;
    evArray.markAllAsTouched();
    evArray.updateValueAndValidity();
    if (evArray.invalid) {
      this.sharedService.showMessageDialog(
        '',
        'Please fix all validation errors before adding a new row.',
        SweetAlertIcon.INFO
      );
      return;
    }
    evArray.push(this.createEVGroup());
  }

  removeEV(index: number): void {
    const evGroup = this.evArray.at(index) as FormGroup;
    const removedIds = this.utilitiesForm.get('removedUtilityIds') as FormArray;
    const evId = evGroup?.get('id')?.value;

    if (
      evId &&
      evId !== '' &&
      evId !== '00000000-0000-0000-0000-000000000000'
    ) {
      removedIds.push(this.formBuilder.control(evId));
    }

    this.evArray.removeAt(index);
    this.evArray.updateValueAndValidity();
  }

  /*  removeSlab(range: any, i: number) {
     this.slabsOf(range).removeAt(i);
   } */
  // Call this before checking .valid
  // helper debug function to list invalid controls
  logInvalidControls(): Array<{ path: string; errors: any }> {
    const results: Array<{ path: string; errors: any }> = [];

    const walk = (control: AbstractControl, path = '') => {
      if (control.invalid && control.errors) {
        results.push({ path, errors: control.errors });
      }
      if (control instanceof FormGroup) {
        for (const k of Object.keys(control.controls)) {
          walk(control.controls[k], path ? `${path}.${k}` : k);
        }
      } else if (control instanceof FormArray) {
        control.controls.forEach((c, i) => walk(c, `${path}[${i}]`));
      }
    };

    walk(this.utilitiesForm, 'utilitiesForm');
    return results;
  }

  private getUploadRawFile(controlName: string): File | null {
    const value = this.utilitiesForm.get(controlName)?.value;
    if (!value) {
      return null;
    }
    if (Array.isArray(value)) {
      return value[0]?.rawFile ?? null;
    }
    return value?.rawFile ?? value;
  }

  submit() {
    const hasGas = this.isUtilityDisplay('Gas');
    const hasWater = this.isUtilityDisplay('Water');
    const hasElectricity = this.isUtilityDisplay('Electricity');
    const hasTriSource = this.isUtilityDisplay('TriSource');
    const hasEV = this.isUtilityDisplay('EV');

    console.log(this.utilitiesForm.getRawValue())
    this.utilitiesForm.markAllAsTouched();
    this.utilitiesForm.updateValueAndValidity({ onlySelf: false, emitEvent: true });

    const invalids = this.logInvalidControls();
    console.log(invalids);
    if (invalids.length) {
      console.warn('Form invalid, see invalids in console');
      this.loaderService.setLoading(false);
      return;
    }

    const payload = this.utilitiesForm.getRawValue();
    console.log('Payload ready:', payload);


    this.loaderService.setLoading(true);
    this.submitted = true;
    console.log(this.utilitiesForm.valid);
    if (this.utilitiesForm.invalid) {
      console.log(this.utilitiesForm.value);
      this.loaderService.setLoading(false);
      return
    } else {

      console.log(this.utilitiesForm.value);
      const utilityJson = {
        projectId: this.projectId,
        water: hasWater ? this.utilitiesForm.get('water')?.value : [],
        electricity: hasElectricity ? this.utilitiesForm.get('electricity')?.value : [],
        trisource: hasTriSource ? this.utilitiesForm.get('trisource')?.value : [],
        EV: hasEV ? this.getEVPayload() : [],
      //  gas: hasGas ? this.utilitiesForm.get('gas')?.value : [],
        gas: hasGas
          ? this.utilitiesForm.get('gas')?.value
          : {
            id: '00000000-0000-0000-0000-000000000000',
            utilityMasterId: '00000000-0000-0000-0000-000000000000',
            gasValue: 0,
            UnitLPGValue: 0,
            unitPrice: 0,
          },

        removedUtilityIds: this.utilitiesForm.get('removedUtilityIds')?.value,
        IsGasFileDeleted: this.utilitiesForm.value.IsGasFileDeleted,
        IsWaterFileDeleted: this.utilitiesForm.value.IsWaterFileDeleted,
        IsTriSourceFileDeleted: this.utilitiesForm.value.IsTriSourceFileDeleted,
        IsElectricityFileDeleted: this.utilitiesForm.value.IsElectricityFileDeleted,
        IsEVFileDeleted: this.utilitiesForm.value.IsEVFileDeleted,
      }
      console.log(utilityJson);
      const formData = new FormData();

      // append JSON object as string
      formData.append("utilityJson", JSON.stringify(utilityJson));
      // Append ONLY files
      const waterFile = this.getUploadRawFile("WaterFile");
      const electricityFile = this.getUploadRawFile("ElectricityFile");
      const triSourceFile = this.getUploadRawFile("triSourceFile");
      const gasFile = this.getUploadRawFile("GasFile");
      const evFile = this.getUploadRawFile("EVFile");

      if (waterFile) {
        formData.append("WaterFile", waterFile);
      }

      if (electricityFile) {
        formData.append("ElectricityFile", electricityFile);
      }

      if (triSourceFile) {
        formData.append("TriSourceFile", triSourceFile);
      }

      if (gasFile) {
        formData.append("GasFile", gasFile);
      }

      if (evFile) {
        formData.append("EVFile", evFile);
      }

      //console.log("payload---------------->", request);

      this.umdService.createutilities_formData(formData).subscribe({
        next: (response) => {
          console.log("Utlity respoces------------>", response);
          if (response && response.statusCode === 201) {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'Success',
              response.message,
              SweetAlertIcon.SUCCESS
            );
          }
        }, error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR
          );
        },

      })
    }


  }

  onWaterInput(event: any) {
    const input = event.target as HTMLInputElement;
    const val = input.value;

    // Replace anything that breaks the 5-digit-before-decimal rule
    const regex = /^(\d{0,25})(\.\d*)?$/;

    if (!regex.test(val)) {
      // Trim the input
      const match = val.match(/^(\d{0,25})/);
      const integerPart = match ? match[1] : '';
      const decimalPart = val.split('.')[1] || '';
      input.value = integerPart + (decimalPart ? '.' + decimalPart : '');
    }
  }
  supplierChanges(event: any) {
    console.log(event);
  }

  /* valiadtion for min and max start  */

  onWaterMinBlur(range: AbstractControl, index: number): void {
    const slab = this.slabsOf(range).at(index);
    const supplier = slab.get('slabName')?.value;
    const min = Number(slab.get('min')?.value);

    if (!supplier || isNaN(min)) return;

    const supplierId = supplier?.id ?? supplier;
    this.validateWaterSlabOverlap(supplierId, min, index, range);
  }
  validateWaterSlabOverlap(
    supplierId: string,
    currentMin: number,
    currentIndex: number,
    range: AbstractControl
  ): void {
    const slabs = this.slabsOf(range);
    const currentSlab = slabs.at(currentIndex);
    let overlapFound = false;

    const currentMax = Number(currentSlab.get('max')?.value);

    // Rule #2 → min < max
    if (!isNaN(currentMin) && !isNaN(currentMax) && currentMax <= currentMin) {
      currentSlab.get('max')?.setErrors({ minGreaterOrEqualMax: true });
    } else {
      const maxCtrl = currentSlab.get('max');
      if (maxCtrl?.hasError('minGreaterOrEqualMax')) {
        const errors = { ...maxCtrl.errors };
        delete errors['minGreaterOrEqualMax'];
        maxCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    // Rule #1 → Overlap check with previous slabs of same supplier
    for (let i = 0; i < slabs.length; i++) {
      if (i === currentIndex) continue;

      const otherSlab = slabs.at(i);

      const otherSupplier = otherSlab.get('slabName')?.value;
      const otherSupplierId = otherSupplier?.id ?? otherSupplier;

      if (supplierId != otherSupplierId) continue;

      const otherMin = Number(otherSlab.get('min')?.value);
      const otherMax = Number(otherSlab.get('max')?.value);

      if (isNaN(otherMin) || isNaN(otherMax)) continue;

      // Overlap detection
      if (currentMin < otherMax && currentIndex > i) {
        currentSlab.get('min')?.setErrors({ slabOverlap: true });
        overlapFound = true;
        break;
      }
    }

    // Clear overlap when fixed
    if (!overlapFound) {
      const control = currentSlab.get('min');
      if (control?.hasError('slabOverlap')) {
        const errors = { ...control.errors };
        delete errors['slabOverlap'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
  }

  onSqftMinBlur_old(index: number, type: string) {
    const ranges = this.waterRangeArray.controls;

    // First row doesn't need validation
    if (index === 0) return;

    const prev = ranges[index - 1];
    const curr = ranges[index];

    const prevMax = +prev.get('sqftMax')?.value;
    const currMin = +curr.get('sqftMin')?.value;

    if (!isNaN(prevMax) && !isNaN(currMin)) {
      if (currMin <= prevMax) {
        curr.get('sqftMin')?.setErrors({
          sqftMinLessThanPrevMax: true,
        });
      } else {
        // Clear error if resolved
        if (curr.get('sqftMin')?.hasError('sqftMinLessThanPrevMax')) {
          curr.get('sqftMin')?.setErrors(null);
          curr.updateValueAndValidity({ onlySelf: true });
        }
      }
    }
  }
  onSqftMinBlur(index: number, type: string) {
    let ranges: AbstractControl[];

    switch (type) {
      case 'Water':
        ranges = this.waterRangeArray.controls;
        break;

      case 'Electricity':
        ranges = this.electricRangeArray.controls;
        break;

      case 'TriSource':
        ranges = this.triRangeArray.controls;
        break;

      default:
        console.error('Invalid type passed to onSqftMinBlur');
        return;
    }

    // First row doesn't need previous check
    if (index === 0) return;

    const prev = ranges[index - 1];
    const curr = ranges[index];

    const prevMax = +prev.get('sqftMax')?.value;
    const currMin = +curr.get('sqftMin')?.value;

    if (!isNaN(prevMax) && !isNaN(currMin)) {
      if (currMin != prevMax) {
        curr.get('sqftMin')?.setErrors({
          sqftMinLessThanPrevMax: true,
        });
      } else {
        // ✅ Clear error if fixed
        if (curr.get('sqftMin')?.hasError('sqftMinLessThanPrevMax')) {
          curr.get('sqftMin')?.setErrors(null);
          curr.updateValueAndValidity({ onlySelf: true });
        }
      }
    }
  }
  onGasValueBlur(event: any) {
    const value = event.target.value;
    if (value && !isNaN(value)) {
      // Round to two decimal places and update the form control value
      const roundedValue = parseFloat(value).toFixed(2);
      // this.utilitiesForm.controls['gasValue'].patch(roundedValue);
      this.utilitiesForm.patchValue({
        gas: {
          gasValue: roundedValue,
        },
      });
    }
  }

  onGasInput(event: any) {
    const input = event.target as HTMLInputElement;
    const val = input.value;

    // Replace anything that breaks the 5-digit-before-decimal rule
    const regex = /^(\d{0,5})(\.\d*)?$/;

    if (!regex.test(val)) {
      // Trim the input
      const match = val.match(/^(\d{0,5})/);
      const integerPart = match ? match[1] : '';
      const decimalPart = val.split('.')[1] || '';
      input.value = integerPart + (decimalPart ? '.' + decimalPart : '');
    }
  }
  /* valiadation end  */

  public onSuccess(): void {
    this.isUploading = false;
  }
  removeGasFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsGasFileDeleted: true });
  }
  uploadGasFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );

        // alert(`Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`);
        return; // Exit the loop after the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsGasFileDeleted: false });
  }
  downloadFile(file: string, fileName: string) {
    this.sharedService.downloadUtilityFiles(file, fileName);
  }
  private calculateUnitPrice(): void {
    const gasValue = this.utilitiesForm.get('gas.gasValue')?.value;
    const UnitLPGValue = this.utilitiesForm.get('gas.UnitLPGValue')?.value;

    // Check if both values are valid and are not empty strings
    if (gasValue && UnitLPGValue && !isNaN(gasValue) && !isNaN(UnitLPGValue)) {
      // Parse values to ensure they are treated as numbers
      const unitPrice = parseFloat(gasValue) * parseFloat(UnitLPGValue);

      // Log the value and its type to confirm
      console.log(unitPrice + ' ---- ' + typeof unitPrice);

      // If you want to round the result to 2 decimal places
      const roundedUnitPrice = unitPrice.toFixed(2);
      // Ensure the unitPrice is updated correctly
      this.utilitiesForm
        .get('gas.unitPrice')
        ?.setValue(roundedUnitPrice.toString(), { emitEvent: false });
    } else {
      // Reset unitPrice if inputs are invalid or empty
      this.utilitiesForm
        .get('gas.unitPrice')
        ?.setValue('', { emitEvent: false });
    }

    console.log(this.utilitiesForm.value);
  }
  getAllConfigData(): void {
    let payload = ['suppliers', 'utilities', 'statuses'];
    this.loaderService.setLoading(true);
    this.sharedService.getAllConfigData(payload).subscribe((res) => {
      if (
        res.statusCode === 200 &&
        res.message === 'Config data retrieved successfully.'
      ) {
        this.configData = res.data;

        // Filter suppliers based on utility type
        this.electricityTypeItems = res?.data?.suppliers.filter(
          (item: any) => item.master.name === 'Electricity'
        );
        this.waterTypeItems = res?.data?.suppliers.filter(
          (item: any) => item.master.name === 'Water'
        );
        this.triSourceItems = res?.data?.suppliers.filter((data: any) => {
          console.log(data.master.name); // Check value of `name` before filtering
          return data.master.name.trim().toLowerCase() === 'trisource'; // Case insensitive comparison
        });
        this.evTypeItems = res?.data?.suppliers.filter(
          (item: any) => item.master.name === 'EV'
        );

        console.log(this.waterTypeItems);

        // Set utility IDs and patch values for respective form groups
        res?.data?.utilities.forEach((item: any) => {
          switch (item?.name) {
            case 'Electricity':
              this.electricityId = item.id;
              // this.patchUtilityArray('electricity', this.electricityId);
              break;
            case 'TriSource':
              this.triSourceId = item.id;
              // this.patchUtilityArray('trisources', this.triSourceId);
              break;
            case 'Water':
              this.waterID = item.id;
              // this.patchUtilityArray('water', this.waterID);
              break;
            case 'Gas':
              this.gasId = item.id;
              this.utilitiesForm.get('gas')?.patchValue({
                utilityMasterId: this.gasId,
              });
              break;
            case 'EV':
              this.evId = item.id;
              this.evArray.controls.forEach((control: AbstractControl) => {
                control.get('utilityMasterId')?.setValue(this.evId);
              });
              break;
          }
        });

        console.log(this.utilitiesForm.value);
      }
    });
  }

  removeWaterFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsWaterFileDeleted: true });
  }
  uploadWaterFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );

        // alert(`Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`);
        return; // Exit the loop after the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsWaterFileDeleted: false });
  }
  removeEleFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsElectricityFileDeleted: true });
  }

  removeTriSourceFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsTriSourceFileDeleted: true });
  }
  removeEVFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsEVFileDeleted: true });
  }
  uploadEleFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );

        // alert(`Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`);
        return; // Exit after finding the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsElectricityFileDeleted: false });
  }

  uploadTriSourceFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        alert(
          `Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`
        );
        return; // Exit after finding the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsTriSourceFileDeleted: false });
  }
  uploadEVFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return;
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault();
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );
        return;
      }
    }

    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsEVFileDeleted: false });
  }
  isClearable(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed === '00000000-0000-0000-0000-000000000000') {
        return false;
      }
      return trimmed !== '' && trimmed !== '-';
    }
    if (typeof value === 'number') {
      return value !== 0;
    }
    if (typeof value === 'object') {
      const raw =
        (value.name ?? value.label ?? value.value ?? value.id ?? '')
          .toString()
          .trim();
      return raw !== '' && raw !== '-';
    }
    return true;
  }
}

